import { createAction, props } from '@ngrx/store';

import { Exhibitor } from '@planone/bau365/util-fair-data';

import {
  CombinedSearchResult,
  ExhibitorEventsResponse,
  ExhibitorPostsResponse,
  ExhibitorProductsResponse,
} from '../../../interfaces/exhibitor.interfaces';

export const exhibitorDirectoryOpenedAnywhere = createAction(
  '[Exhibitor Page] Directory opened anywhere',
  props<{ fairId: string }>()
);

export const exhibitorDirectoryOpened = createAction(
  '[Exhibitor Page] Directory opened',
  props<{ letter: string; fairId: string }>()
);

export const exhibitorDirectoryLoadSucceeded = createAction(
  '[Exhibitor API] Exhibitor directory load succeeded',
  props<{
    letter: string;
    results: CombinedSearchResult[];
    loaded: number;
    fairId: string;
    count?: number;
  }>()
);
export const exhibitorDirectoryLoadNext = createAction(
  '[Exhibitor API] Exhibitor directory load next chunk',
  props<{
    letter: string;
    results: CombinedSearchResult[];
    loaded: number;
    fairId: string;
    count?: number;
  }>()
);

export const exhibitorDirectoryHallsOpened = createAction(
  '[Exhibitor Page] Directory halls opened',
  props<{ hall: string; fairId: string }>()
);

export const exhibitorDirectoryHallsInitSucceeded = createAction(
  '[Exhibitor API] Exhibitor directory load hall list succeeded',
  props<{
    halls: string[];
    fairId: string;
  }>()
);

export const exhibitorDirectoryHallLoadNext = createAction(
  '[Exhibitor API] Exhibitor directory hall load next chunk',
  props<{
    hall: string;
    results: CombinedSearchResult[];
    loaded: number;
    fairId: string;
    count?: number;
  }>()
);

export const exhibitorDirectoryHallLoadSucceeded = createAction(
  '[Exhibitor API] Exhibitor directory hall load hall succeeded',
  props<{
    hall: string;
    results: CombinedSearchResult[];
    loaded: number;
    fairId: string;
    count?: number;
  }>()
);

export const exhibitorDirectorySearchOpened = createAction(
  '[Exhibitor Page] Directory page opened with search',
  props<{ searchTerm: string; fairId: string }>()
);

export const exhibitorDirectorySearchLoadNext = createAction(
  '[Exhibitor API] Exhibitor directory search load next chunk',
  props<{
    searchTerm: string;
    fairId: string;
    results?: CombinedSearchResult[];
    loaded?: number;
    count?: number;
  }>()
);

export const exhibitorDirectorySearchLoadNextSucceeded = createAction(
  '[Exhibitor API] Exhibitor directory search load next succeeded',
  props<{
    searchTerm: string;
    results: CombinedSearchResult[];
    fairId: string;
    count?: number;
  }>()
);

export const exhibitorDirectorySearchLoadSucceeded = createAction(
  '[Exhibitor API] Exhibitor directory search load succeeded',
  props<{
    searchTerm: string;
    results: CombinedSearchResult[];
    fairId: string;
    count?: number;
  }>()
);

export const exhibitorDirectoryLoadFailed = createAction(
  '[Exhibitor API] Exhibitor directory load failed',
  props<{ error: string; fairId: string }>()
);
export const exhibitorOpened = createAction(
  '[Exhibitor Page] Opened',
  props<{ exhibitorId: string; contactPersonIndex?: string; fairId: string }>()
);
export const exhibitorContactPersonOpened = createAction(
  '[Exhibitor Page] Contact person details opened',
  props<{ exhibitorId: string; contactPersonIndex: string; fairId: string }>()
);

export const exhibitorFairTabOpened = createAction(
  '[Exhibitor Page] Fair tab opened',
  props<{ exhibitorId: string; fairId: string }>()
);

export const exhibitorLoadSucceeded = createAction(
  '[Exhibitor API] Exhibitor load succeeded',
  props<{ exhibitor: Exhibitor; fairId: string; contactPersonIndex?: string }>()
);
export const exhibitorParentLoadSucceeded = createAction(
  '[Exhibitor API] Exhibitor parent load succeeded',
  props<{ exhibitor: Exhibitor; fairId: string }>()
);
export const exhibitorLoadFailed = createAction(
  '[Exhibitor API] Exhibitor load failed',
  props<{ error: string; fairId: string }>()
);

export const exhibitorCoExhibitorLoadSucceeded = createAction(
  '[Exhibitor API] Co-Exhibitor load succeeded',
  props<{ exhibitor_id: string; exhibitors: Exhibitor[]; fairId: string }>()
);

export const exhibitorProductsLoadSucceeded = createAction(
  '[Exhibitor API] Exhibitor products load succeeded',
  props<{ exhibitorProductsResponse: ExhibitorProductsResponse; exhibitorId: string; fairId: string }>()
);
export const exhibitorProductsLoadNext = createAction(
  '[Exhibitor API] Exhibitor products load next chunk',
  props<{ exhibitorProductsResponse: ExhibitorProductsResponse; exhibitorId: string; fairId: string }>()
);
export const exhibitorProductsLoadFailed = createAction(
  '[Exhibitor API] Exhibitor products load failed',
  props<{ error: string; fairId: string }>()
);
export const exhibitorPostsLoadSucceeded = createAction(
  '[Posts API] Exhibitor posts load succeeded',
  props<{ exhibitorPostsResponse: ExhibitorPostsResponse; exhibitorId: string; fairId: string }>()
);
export const exhibitorPostsLoadNext = createAction(
  '[Posts API] Exhibitor posts load next chunk',
  props<{ exhibitorPostsResponse: ExhibitorPostsResponse; exhibitorId: string; fairId: string }>()
);
export const exhibitorPostsLoadFailed = createAction(
  '[Posts API] Exhibitor posts load failed',
  props<{ error: string; fairId: string }>()
);

export const exhibitorEventsLoadSucceeded = createAction(
  '[Posts API] Exhibitor events load succeeded',
  props<{ exhibitorEventsResponse: ExhibitorEventsResponse; exhibitorId: string; fairId: string }>()
);
export const exhibitorEventsLoadNext = createAction(
  '[Events API] Exhibitor events load next chunk',
  props<{ exhibitorEventsResponse: ExhibitorEventsResponse; exhibitorId: string; fairId: string }>()
);
export const exhibitorEventsLoadFailed = createAction(
  '[Events API] Exhibitor events load failed',
  props<{ error: string; fairId: string }>()
);
